import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Star, ScrollText } from "lucide-react";
import { Avatar } from "../components/Avatar";
import { api, getChildId } from "../lib/api";

export default function Rewards() {
  const [r, setR] = useState(null);
  const nav = useNavigate();
  useEffect(() => {
    api.get(`/children/${getChildId()}/rewards`).then(({ data }) => setR(data)).catch(() => nav("/profiles"));
  }, [nav]);
  if (!r) return <div className="min-h-screen paper-bg" />;
  return (
    <div className="min-h-screen paper-bg px-6 sm:px-12 py-6" data-testid="rewards-page">
      <button data-testid="rewards-back-btn" onClick={() => nav(-1)} className="kid-btn bg-white border-2 border-[var(--line)] px-6 flex items-center gap-2"><ArrowLeft /> 返回</button>
      <div className="flex items-center gap-5 mt-8">
        <div className="text-7xl w-24 h-24 flex items-center justify-center"><Avatar value={r.avatar} /></div>
        <div>
          <h1 className="font-brush text-6xl text-[var(--vermilion)]">我的寶箱</h1>
          <div className="flex gap-6 mt-2 text-2xl font-black">
            <span className="flex items-center gap-2 text-amber-500" data-testid="rewards-stars"><Star fill="currentColor" /> {r.stars}</span>
            <span className="flex items-center gap-2 text-[var(--tea)]" data-testid="rewards-scrolls"><ScrollText /> {r.scrolls}</span>
          </div>
        </div>
      </div>
      <h2 className="font-serif-tc text-2xl font-bold mt-10 mb-4 text-[var(--tea)]">徽章</h2>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-4" data-testid="rewards-badges">
        {r.badges.length === 0 && <p className="text-stone-500 col-span-full font-en">Finish a story to earn your first badge!</p>}
        {r.badges.map((b, i) => (
          <motion.div key={b.id} initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: i * 0.05, type: "spring" }}
            className="scroll-card p-4 flex flex-col items-center text-center" data-testid={`badge-${b.id}`}>
            <div className="text-5xl">{b.icon}</div>
            <div className="font-serif-tc font-bold mt-2">{b.name}</div>
          </motion.div>
        ))}
      </div>
      <h2 className="font-serif-tc text-2xl font-bold mt-10 mb-4 text-[var(--tea)]">貼紙</h2>
      <div className="flex flex-wrap gap-4" data-testid="rewards-stickers">
        {r.stickers.map((s) => <div key={s} className="w-24 h-24 rounded-full bg-white border-4 border-dashed border-amber-300 flex items-center justify-center text-5xl rotate-[-6deg]">{s}</div>)}
      </div>
    </div>
  );
}
